<div class="card new-card" [ngStyle]="{'margin-bottom': isTruck ? '30px' : '0px'}">
    <app-card-title [title]="isTruck ? 'Eixos e Pneus' : 'Pneus'" icon="aar-icon-tires"></app-card-title>
    <div class="axle-container">
        <div class="axle-left">
          <ng-container *ngFor="let axle of data?.axleAndTire?.axles; let i = index">
            <app-evaluation-axle class="axle-component" [index]="i" [activeAxle]="axle.tireCount == 4"
              [quantityTires]="axle.tireCount" [isReportItem]="true" [tiresFormArray]="tiresByAxle.get(i + 1)"
              [permitiEditing]="false"></app-evaluation-axle>
          </ng-container>
          <div class="legend">
            <div class="legend-item">
              <span class="legend-color green"></span>Bom
            </div>
            <div class="legend-item">
              <span class="legend-color red"></span>Ruim
            </div>
            <div class="legend-item">
              <span class="legend-color yellow"></span>Regular
            </div>
            <div class="legend-item">
              <span class="legend-color grey"></span>Não avaliado
            </div>
          </div>
        </div>
        <div class="axle-right" *ngIf="isTruck">
          <div class="info-wrapper">
            <div class="info-section">
              <span>Eixos</span>
              <p>Quantidade: <b>{{ data?.axleAndTire?.axles?.length }}</b></p>
              <p>Distância entre eixos: <b>{{ data?.axleAndTire?.tiresDimension ?
                  (data.axleAndTire.tiresDimension + 'mm') : '-' }}</b></p>
            </div>
            <div class="info-section">
              <span>Pneus</span>
              <p>Quantidade: <b>{{ tiresCount }}</b></p>
              <p>Dimensão: <b>{{ data?.axleAndTire?.tiresDimension || '-' }}</b></p>
              <p>Step: <b>{{ data?.axleAndTire?.stepQuantity || '-' }}</b></p>
            </div>
          </div>
          <!-- <a href="#" class="classification-link">Sobre a classificação dos pneus.</a> -->
        </div>
      </div>
</div>
